const getters = {
  getViewerCampaigns(state) {
    return state.campaigns;
  },
};

export default getters;
